<template>
  <div v-cloak>
    <transition name="fade" appear appear-active-class="fade-enter-active">

        <TenderComponent :set-section="setSection"/>

    </transition>
  </div>
</template>

<script>

import TenderComponent from '@/components/tenders/TenderComponent.vue'

export default {
  name: 'Tender',
  props: ['setSection'],
  components: {
    TenderComponent
  }
}
</script>

<style lang="scss">
@import "../styles/main.scss";
</style>

<style scoped lang="scss">
</style>
